<template>
    <div
        class="relative flex cursor-pointer flex-col border p-2 hover:border-black-text hover:bg-white"
        :class="{
            'border-tile-gray bg-tile-gray':
                store.selectedMetrika?.NAZEV_UDAJE_DATA !==
                item.NAZEV_UDAJE_DATA,
            'border-black-text bg-white':
                store.selectedMetrika?.NAZEV_UDAJE_DATA ===
                item.NAZEV_UDAJE_DATA,
        }"
        @click="handleClick"
    >
        <div class="h-16 text-sm">
            {{ useLocaleValue(item, "NAZEV_UDAJE")
            }}{{ store.selectedLocality ? ":" : "" }}
        </div>
        <div class="flex flex-col gap-px font-promedium">
            <div
                v-for="(jednotka, index) in item.NAZEV_UDAJE_DATA.split(',')"
                :key="jednotka"
            >
                <span class="text-lg">{{
                    getValue(jednotka, index) + " "
                }}</span>
                <span
                    v-if="
                        store.selectedLocality &&
                        store.selectedLocality[jednotka]
                    "
                    class="text-xs"
                    v-html="
                        item.JEDNOTKA_ZOBRAZ.split(',')[index]?.replace(
                            'm2',
                            'm<sup>2</sup>'
                        )
                    "
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const mainStore = useMainStore()
const store = useKlokStore()
const props = defineProps<{
    item: KlokMetrikaItem
}>()

function getValue(jednotka: string, index: number) {
    if (!store.selectedLocality) return ""
    if (!store.selectedLocality[jednotka]) return "–"
    const toFixed = store.selectedLocality[jednotka].toFixed(
        Array.isArray(props.item.DESETINNA_MISTA)
            ? props.item.DESETINNA_MISTA.split(",")[index]
            : props.item.DESETINNA_MISTA
    )

    return toFixed
        .replace(
            /(\d|\uE000)(?=(\d{3}|\d{3}\uE000|\d\uE000\d{2}|\d{2}\uE000\d|\uE000\d{3}|\d\uE000\d\uE000\d|\uE000\d\uE000r\d\uE000\d|\d\uE000\d\uE000\d\uE000)+(?!(\d|\uE000\d|\d\uE000)))/g,
            "$1" + "\u202F"
        )
        .replace(".", ",")
}

function handleClick() {
    if (
        store.selectedMetrika?.NAZEV_UDAJE_DATA === props.item.NAZEV_UDAJE_DATA
    ) {
        store.selectedMetrika = null
        return
    }
    store.selectedMetrika = props.item
    mainStore.mobileLeftPanelOpen = false
}
</script>

<style scoped></style>
